import { render, staticRenderFns } from "./QuickbuyVerificationDetailsPhotos.vue?vue&type=template&id=7c820422&"
import script from "./QuickbuyVerificationDetailsPhotos.vue?vue&type=script&lang=js&"
export * from "./QuickbuyVerificationDetailsPhotos.vue?vue&type=script&lang=js&"
import style0 from "./QuickbuyVerificationDetailsPhotos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports